<template>
  <div class="language">
    <span class="title" @click="show"
      >LANGUAGE<i class="down-arrow-icon"></i
    ></span>
    <div class="dropdown-box" id="dropBox">
      <LanguageBox v-model="language" />
    </div>
  </div>
</template>
<script>
import * as types from '../../store/mutation-types'
import LanguageBox from './LanguageBox'

export default {
  name: 'language',
  components: { LanguageBox },
  data() {
    return {
      language: []
    }
  },
  methods: {
    show(event) {
      event.preventDefault()
      event.stopPropagation()
      this.$store.dispatch(types.SET_GLOBAL_DROPDOWNMODE, 'clear')
      const el = document.querySelector('#dropBox')
      console.log('el:', el.className)
      if (el.className === 'dropdown-box') {
        el.className += ' active'
      } else {
        el.className = 'dropdown-box'
      }
    }
  },
  updated() {
    this.$emit('model', this.language)
  }
}
</script>

<style lang="scss" scoped>
.language {
  width: 110px;
  position: relative;

  .title {
    width: 102px;
    height: 23px;
    font-size: 14px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.9px;
    text-align: left;
    color: #000000;
    cursor: pointer;

    .down-arrow-icon {
      margin: 0 0 0 8px;
      width: 16px;
      height: 9px;
      display: inline-block;
      background-image: url('../../assets/images/etc/down-arrow.png');
    }
  }

  .dropdown-box {
    width: 252px;
    z-index: -1;
    top: 40px;
    right: 0;
    visibility: hidden;
    opacity: 0;
    background-color: #ffffff;
    position: absolute;

    &:before {
      position: absolute;
      top: -11px;
      right: 20px;
      z-index: 1001;
      content: '';
      width: 20px;
      height: 20px;
      border-top: 1px solid #cbcbcb;
      border-right: 1px solid #cbcbcb;
      transform: rotate(315deg);
      background-color: #fff;
    }

    .LanguageBox {
      border: 1px solid #cbcbcb;
      width: 100%;
      height: 164px;
    }

    transition-property: width height background-color font-size left top
      transform transform color;
    transition-duration: 0.3s;
    transition-timing-function: ease-in-out;
  }

  .active {
    height: 159px;
    z-index: 1000;
    opacity: 1;
    visibility: visible;

    transition-property: width height background-color font-size left top
      transform transform color;
    transition-duration: 0.3s;
    transition-timing-function: ease-in-out;
  }
}
</style>
